






import { Vue, Prop, Component } from 'vue-property-decorator'

const constraints = { audio: false, video: { width: { ideal: 1280 }, height: { ideal: 720 } }}
// tslint:disable-next-line
const RecordRTC = require('recordrtc')

export default class MediaVideo extends Vue {
  recorder: any = null
  camera: any = null
  videoContent: any = null

  getCameraPermissions() {
    if (navigator.mediaDevices === undefined) {
      return Promise.reject()
    }
    return navigator.mediaDevices.getUserMedia(constraints)
  }

  async initVideo() {
    this.camera = await this.getCameraPermissions()
    const video: any = document.querySelector('video') || ''
    video.muted = true
    video.volume = 0
    video.srcObject = this.camera
    // console.log('MediaVideo', 'init video')
  }

  initRTC() {
    this.recorder = RecordRTC(this.camera, {
      type: 'video',
      mimeType: 'video/webm',
      frameRate: 1,
    })
    // console.log('MediaVideo', 'init RTC')
  }

  startRecord() {
    const video: any = document.querySelector('video')
    this.recorder.camera = this.camera
    this.recorder.startRecording()
    this.videoContent = video
    // console.log('MediaVideo', 'start rtc')
  }

  pauseRecord() {
    this.videoContent.pause()
    this.recorder.pauseRecording()
    // console.log('MediaVideo', 'pause record')
  }

  stopVideo() {
    this.videoContent.src = null
    this.videoContent.srcObject = null
    this.videoContent.muted = false
    this.videoContent.volume = 1
    this.videoContent.src = URL.createObjectURL(this.recorder.getBlob())
    // console.log('MediaVideo', 'final video')
  }

  // stop use RTC record
  stopRTC() {
    return new Promise((resolve, reject) => {
      this.recorder.stopRecording(() => {
        this.stopVideo()
        resolve()
      })
    })
  }

  destroyCamera() {
    this.recorder.camera.stop()
    this.recorder.destroy()
  }
}
